import { IWidget_Subtype } from '@bridebook/models/source/models/Places/Widgets.types';
import { SearchWidget } from './get-seo-data';

export enum QuickFactTheme {
  Purple = 'purple',
  Green = 'green',
  Orange = 'orange',
  Red = 'red',
}

export interface IQuickFactContent {
  subType: IWidget_Subtype | null;
  theme: QuickFactTheme;
  title: string | null;
  content: string | null;
  description: string | null;
  order: number;
}

export interface IEverythingToKnowContent {
  title: string | null;
  column1: string | null;
  column2: string | null;
  order: number;
}

export interface IVideoWidget {
  title: string;
  content: string;
}

export interface IMapWidget {
  title: string;
}

export const mapQuickFactsContent = (searchWidgets?: SearchWidget[]): IQuickFactContent[] => {
  if (!searchWidgets) {
    return [];
  }
  return searchWidgets
    .filter((widget) => widget.widgetType === 'quickFacts')
    .map((widget) => ({
      subType: widget.widgetSubtype || null,
      theme: (widget.theme as QuickFactTheme) || QuickFactTheme.Purple,
      title: widget.title || null,
      content: widget.content || null,
      description: widget.description || null,
      order: widget.order || 0,
    }))
    .sort((a, b) => a.order - b.order);
};

export const mapEverythingToKnowContent = (
  searchWidgets?: SearchWidget[],
): IEverythingToKnowContent[] => {
  if (!searchWidgets) {
    return [];
  }
  return searchWidgets
    .filter((widget) => widget.widgetType === 'everythingYouNeedToKnow')
    .map((widget) => ({
      title: widget.title || null,
      column1: widget.column1 || null,
      column2: widget.column2 || null,
      order: widget.order || 0,
    }))
    .sort((a, b) => a.order - b.order);
};

export const getVideoWidget = (searchWidgets?: SearchWidget[]): IVideoWidget | null => {
  if (!searchWidgets) {
    return null;
  }
  return (
    searchWidgets
      .filter((widget) => widget.widgetType === 'videoWidget')
      .map((widget) => ({
        title: widget.title || '',
        content: widget.content || '',
      }))[0] || null
  );
};

export const getGoogleMapWidget = (searchWidgets?: SearchWidget[]): IMapWidget | null => {
  if (!searchWidgets) {
    return null;
  }
  return (
    searchWidgets
      .filter((widget) => widget.widgetType === 'mapWidget')
      .map((widget) => ({
        title: widget.title || '',
      }))[0] || null
  );
};
